export const Grade = { A: "A", B: "B", C: "C", D: "D", E: "E" } as const;
export type Grade = (typeof Grade)[keyof typeof Grade];
